import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 1、创建路由组件
// 2、将路由与组件进行映射
// 3、创建router实例
// 4、将router挂载到根节点上，从而让整个应用都有路由功能
const routes = [
    // 主路由
    {
        path: '/',
        name: 'Main',
        component: () => import('../views/Main.vue'),  
        redirect: '/home',  // 重定向，当路径为 / 时跳转到 home
        children: [
            // 子路由
            {
                path: 'home',
                name: 'home',
                component: () => import('../views/Home.vue')  
            },
            {
                path: 'model',
                name: 'model',
                component: () => import('../views/Model.vue')  
            },
            {
                path: 'search',
                name: 'search',
                component: () => import('../views/Search.vue')  
            }
        ]
    },
]
const router = new VueRouter({
    routes // 相当于：routes: routes
})
export default router
